import React, { useState, useRef, useEffect } from 'react';
import * as S from './AboutButton.style';
import { trackEvent } from '../../services/analytics';

export const AboutButton: React.FC = () => {
  const [showPopover, setShowPopover] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setShowPopover(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <S.Wrapper ref={wrapperRef}>
      <S.Btn
        onClick={() => {
          setShowPopover((previous) => {
            const next = !previous;
            if (next) {
              trackEvent('about_open');
            }
            return next;
          });
        }}
      >
        [ about ]
      </S.Btn>

      {showPopover && (
        <S.Popover onClick={(e) => e.stopPropagation()}>
          <S.Title>About semn.ai</S.Title>

          <S.Paragraph>You are surrounded by infinite noise and delayed narratives,</S.Paragraph>
          <S.Paragraph>yet you make irreversible decisions in real time.</S.Paragraph>
          <S.Paragraph>semn.ai closes that gap for Bitcoin.</S.Paragraph>
          <S.Paragraph>
            It reads market microstructure at the resolution it operates. Tick by tick, regime
            aware.
          </S.Paragraph>
          <S.Paragraph>
            Every metric is built to collapse complexity and reveal structural state.
          </S.Paragraph>

          <S.Divider />

          <S.SectionTitle>What this is</S.SectionTitle>
          <S.List>
            <S.ListItem>A structural awareness surface for Bitcoin</S.ListItem>
            <S.ListItem>
              Per-tick regime detection: volatility state, orderflow imbalance, transition
              probabilities
            </S.ListItem>
            <S.ListItem>AI regime synthesis reading the same live data you see</S.ListItem>
          </S.List>

          <S.Divider />

          <S.SectionTitle>What this is not</S.SectionTitle>
          <S.List>
            <S.ListItem>Not a signal service</S.ListItem>
            <S.ListItem>Not trade advice</S.ListItem>
            <S.ListItem>Not entries, exits, or position sizing</S.ListItem>
            <S.ListItem>Not guaranteed outcomes</S.ListItem>
          </S.List>

          <S.Divider />

          <S.SectionTitle>How to use it</S.SectionTitle>
          <S.StepLine>See the market's structural output.</S.StepLine>
          <S.StepLine>Understand which regime the data describes.</S.StepLine>
          <S.StepLine>Decide based on structure, not narrative.</S.StepLine>

          <S.Divider />

          <S.SectionTitle>Design principle</S.SectionTitle>
          <S.Emphasis>See. Understand. Decide.</S.Emphasis>

          <S.Divider />

          <S.SectionTitle>Origin</S.SectionTitle>
          <S.Paragraph>The name references the Semnai Theai (“Venerable Ones”).</S.Paragraph>
        </S.Popover>
      )}
    </S.Wrapper>
  );
};
